import React, { useState } from 'react';
import './UpdateCredentialsModal.css';
import PasswordField from './PasswordField';
import PasswordChecklist from './PasswordChecklist';
import { checkPassword } from '../utils/passwordPolicy';

// Profile → Change password. 2026-10-28: this replaced "Update email/password", a dialog whose submit
// only logged what was typed to the console and closed — it never saved anything. The email has its
// own dialog now (ChangeEmailModal), with a code to the new address; the two are protected
// differently and so are changed separately, as on the phone.
const ChangePasswordModal = ({ onClose, currentUserId, userData, addNotification }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const who = { username: userData?.username, email: userData?.email };
  const strong = checkPassword(newPassword, who).ok;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) {
      setError('The new password and its confirmation do not match.');
      return;
    }
    setBusy(true);
    try {
      const response = await fetch(`/api/users/${currentUserId}/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setError(data.message || 'The password could not be changed.');
        return;
      }
      addNotification?.('Your password has been changed.', 'green');
      onClose();
    } catch (_) {
      setError('No connection. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="update-credentials-modal-overlay">
      <div className="update-credentials-modal-content">
        <div className="update-credentials-modal-header">
          <h2>Change password</h2>
          <button className="update-credentials-modal-close-button" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="update-credentials-modal-body">
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="field-label" htmlFor="current-password">Current password</label>
              <PasswordField className="control" id="current-password" autoComplete="current-password"
                value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
            </div>
            <div className="field">
              <label className="field-label" htmlFor="new-password">New password</label>
              <PasswordField className="control" id="new-password" autoComplete="new-password"
                value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
              <PasswordChecklist password={newPassword} username={who.username} email={who.email} />
            </div>
            <div className="field">
              <label className="field-label" htmlFor="confirm-password">Confirm new password</label>
              <PasswordField className="control" id="confirm-password" autoComplete="new-password"
                value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
            </div>
            {error && <p className="reset-error" role="alert" style={{ color: 'var(--danger, #c62828)', margin: 0 }}>{error}</p>}
            <div className="btn-row">
              <button type="submit" className="btn btn--primary" disabled={busy || !strong}>{busy ? 'Changing…' : 'Change password'}</button>
              <button type="button" className="btn btn--secondary" onClick={onClose}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
